import React, { useEffect } from 'react';
import './MainLayoutContainer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDesktop, faMobileAlt } from '@fortawesome/free-solid-svg-icons';

function deleteDivGenerateBtnBlocker() {
	const blocker = document.querySelector(".generateBtnBlockerClass")
    const imgLastInfoModal=document.querySelector(".imgCloudFirst")
    const generateBtn = document.querySelector(".generate-btn")
    
    if(blocker!=null){
        blocker.remove()
        generateBtn.style.zIndex="0"
        
    }
    if(imgLastInfoModal!=null){

        imgLastInfoModal.remove();
    }

    
}

const Preview = ({isOpen, preview}) => {
    let previewStyle = {};
    if (isOpen) {
        previewStyle = {display: "none"};
    }
    return (
        <div className="main__preview" style={previewStyle}>
            {preview}
        </div>
    );
}

const Navbar = ({isOpen, children}) => {
    const navbarStyle = {};
    if (!isOpen) {
        navbarStyle.display = "none";
    }
    return (
        <div className="navbar" style={navbarStyle}>
            {children}
        </div>
    );
}

const Sidebar = ({ isOpen, children }) => {
    const sidebarStyle = {};
    if (!isOpen) {
        sidebarStyle.display = "none";
    }
    return (
        <div className="sidebar" style={sidebarStyle}>
            {children}
        </div>
    );
}

const Content = ({ isOpen, header, elements, isPreviewOpen, isMobileOn, handleMobilePreview }) => {

    useEffect(() => {
        widgetOnScroll();
      }, [elements]);
    
    const headerStyle = {};
    if (!isOpen) {
        headerStyle.display = "none";
    }
    
    const previewTypeStyle = {};
    if (isPreviewOpen) {
        previewTypeStyle.display = "none";
    } else {
        previewTypeStyle.cursor = "pointer";
    }
    
    const getDesktopIconClass = () => {
        if (isMobileOn) {
            return "inactiveIcon";
        }
        return "activeIcon";
    };
    
    const getMobileIconClass = () => {
        if (isMobileOn) {
            return "activeIcon";
        }
        return "inactiveIcon";
    };
    
    return (
    <div className="content" onMouseOver={deleteDivGenerateBtnBlocker}>
        <div className="content__header" style={headerStyle}>
            {header}
        </div>
        <div className="previewType-container" style={previewTypeStyle} >
            <div className="previewType-select" onClick={handleMobilePreview}>
                <FontAwesomeIcon icon={faDesktop} size="1x" className={getDesktopIconClass()}/>
                <FontAwesomeIcon icon={faMobileAlt} size="1x" className={getMobileIconClass()}/>
            </div>
        </div>
        <div className="content__elements" onScroll={widgetOnScroll}>
            {elements}
        </div>
    </div>
    )
}

const MainLayoutContainer = ({isPreviewOpen, isMobileOn, handleMobilePreview, preview , isNavbarOpen, isSideBarOpen, isHeaderOpen, navbarContent, sidebarContent, header, elements}) => (
    <div className="main">
        <Navbar isOpen={isNavbarOpen}>
            {navbarContent}
        </Navbar>

        <Preview isOpen={isHeaderOpen} preview={preview} />
        <div className="main__container">
            <Sidebar isOpen={isSideBarOpen}>
                {sidebarContent}
            </Sidebar>
            <Content isOpen={isHeaderOpen}
                header={header}
                elements={elements}
                isMobileOn={isMobileOn}
                isPreviewOpen={isPreviewOpen}
                handleMobilePreview={handleMobilePreview}
            />
        </div>
    </div>
);

const deleteInlineStyle = () => { 
    const sortableListItems = document.querySelectorAll('.sortable-list__item');
    sortableListItems.forEach(item => {
        if(item.style.top){
            item.style.removeProperty('top');
        }
      
    });
}

const widgetOnScroll = () => {

    const contentElements = document.querySelector('.content__elements');
    const sortableListItems = document.querySelectorAll('.sortable-list__item');
    const widgetElementRightTop = document.querySelector('.sortable-list__popup__widget1__rightTop');
    const widgetElementLeftTop = document.querySelector('.sortable-list__popup__widget1__leftTop');
    const widgetElementLeftBottom = document.querySelector('.sortable-list__popup__widget1__leftBottom');
    const widgetElementRightBottom = document.querySelector('.sortable-list__popup__widget1__rightBottom');
    
    const widgetElementsArray = [widgetElementRightTop, widgetElementLeftTop, widgetElementLeftBottom, widgetElementRightBottom]

    widgetElementsArray.forEach((widgetElement) => {

        const headerHeight = contentElements.children[0].getBoundingClientRect().height;
        if(widgetElement!==null){
            const scrollTop = contentElements.pageYOffset || contentElements.scrollTop;
            let top=0;
            if(headerHeight>250){
              
                if (widgetElement===widgetElementLeftBottom || widgetElement===widgetElementRightBottom) {
                    top=150;
                }      
            }
            else{
                top=0;
                if (widgetElement===widgetElementLeftBottom || widgetElement===widgetElementRightBottom) {
                    top=230;
                }
                   
            }
            const elementTop = top + scrollTop
            widgetElement.style.top = `${elementTop}px`;
        }
    })
    
    sortableListItems.forEach((element) => {
        if (element.classList.length === 1) {
          element.style.top = '50';
        }
      });
      deleteInlineStyle()
}

export default MainLayoutContainer;